"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActiveIcmBanner = void 0;
// import * as React from "react";
// import { MessageBar, MessageBarType } from "@fluentui/react";
// import { compiler } from "markdown-to-jsx";

/**
 * This banner will be displayed on the home page (product list), product page,
 * and repo owner panel. Uncomment out everything out and update the `activeIcm` text
 * to display a message to all customers.
 */
var ActiveIcmBanner = function ActiveIcmBanner() {
  return null;
  // return (
  //     <MessageBar
  //         messageBarType={MessageBarType.warning}
  //     >
  //         {compiler(t("activeIcm"))}
  //     </MessageBar>
  // );
};
exports.ActiveIcmBanner = ActiveIcmBanner;